<mat-slider
  *ngIf="videoControls.ready$ | async"
  min="0"
  step="0.1"
  [max]="videoControls.duration$ | async"
  [value]="videoControls.currentTime$ | async"
  (input)="scrubVideo($event.value)"
></mat-slider>
